import { Upload } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import DropZone from '../drop-zone/DropZone'
import { useFileUploadContext } from '../upload-files/FileUploadProvider'

export default function UploadBox() {
  const { handleFilesSelectedToUpload } = useFileUploadContext()

  return (
    <DropZone onDrop={handleFilesSelectedToUpload}>
      <Stack
        component="label"
        tabIndex={0}
        spacing={3}
        alignItems="center"
        sx={{
          height: '100%',
          border: (theme) => `solid 2px ${theme.palette.secondary.main}`,
          borderRadius: 4,
          p: 2,
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          ':hover': {
            background: '#0008',
          },
        }}
      >
        <Upload
          sx={{
            fontSize: 32,
            border: (theme) => `dotted 4px ${theme.palette.secondary.main}`,
            borderRadius: '50%',
            p: 1.5,
            boxSizing: 'content-box',
          }}
        />
        <div>
          <Typography variant="h5" textAlign="center">
            Upload Documents
          </Typography>
          <Typography variant="caption" textAlign="center">
            Drop documents here to begin processing them.
          </Typography>
        </div>
        <input
          onChange={(e) => {
            if (!e.target.files) return
            handleFilesSelectedToUpload(e.target.files)
          }}
          type="file"
          accept="image/*,.pdf"
          style={{ display: 'none' }}
          multiple
        />
      </Stack>
    </DropZone>
  )
}
